export default "__VITE_ASSET__jVqi7pD9__"